import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ThreeColumnSection from './components/ThreeColumnSection';
import MainButtons from './components/MainButtons';
import CurrentOverview from './components/CurrentOverview';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <ThreeColumnSection />
      <MainButtons />
      <CurrentOverview />
      <BlogSection />
      <Footer />
    </div>
  );
}